import { canManageAmeCampaigns } from './accessControl'

/**
 * Блог staff access — same gate as Ame campaigns (password BO, not marketing-only).
 */
export const canAccessBlog = (user) => canManageAmeCampaigns(user)

export default canAccessBlog
